/**
 * Detect whether local Supabase GoTrue has Azure/Entra enabled.
 *
 * Prefer `/auth/v1/settings` over `/authorize` — authorize issues a 302 to
 * Microsoft, and a `fetch(..., { redirect: 'manual' })` shows up in DevTools
 * as a canceled `login.microsoftonline.com` request (false alarm).
 *
 * Returns `null` when the browser cannot tell — callers must not block SSO.
 */
export async function probeAzureSsoReady(supabaseUrl: string): Promise<boolean | null> {
  try {
    const res = await fetch(`${supabaseUrl.replace(/\/$/, '')}/auth/v1/settings`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const body = (await res.json()) as {
      external?: Record<string, boolean | undefined>;
    };
    const azure = body.external?.azure;
    if (typeof azure === 'boolean') return azure;
    return null;
  } catch {
    return null;
  }
}

/** True when the configured Supabase URL points at the local CLI stack. */
export function isLocalSupabaseUrl(url: string | undefined): boolean {
  if (!url) return false;
  return url.includes('127.0.0.1') || url.includes('localhost');
}
